// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__Tj9pj","title":"Tooltip_title__2appN"};